import React, { Component } from "react";
import { MnemoLoading, Title } from "components/misc";
import { Container } from "design-react-kit";
import { withRouter } from "react-router-dom";
import { AdminLessonTrainingAnalyticsForm } from "components/forms/admin/AdminLessonTrainingAnalyticsForm";
import { adminService, dateHelper, networkErrorHelper } from "libs";

class LessonTrainingScheduleAnalytics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idLessonTrainingSchedule: 0,
      loading: true,
      lessonTraining: null,
    };

    const idLessonTrainingSchedule = parseInt(
      this.props.match.params.idLessonTrainingSchedule
    );

    if (idLessonTrainingSchedule) {
      this.loadRemote(idLessonTrainingSchedule);
    }
  }

  loadRemote(idLessonTrainingSchedule) {
    const filter = {
      searchFilter: {
        id: idLessonTrainingSchedule,
      },
    };

    adminService
      .loadTrainingSchedule(filter)
      .then(({ data }) => {
        this.setState({
          loading: false,
          idLessonTrainingSchedule: idLessonTrainingSchedule,
          lessonTraining: data.payload.trainingSchedule,
        });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  }

  render() {
    const { idLessonTrainingSchedule, loading, lessonTraining } = this.state;

    if (loading) return <MnemoLoading />;
    let title = "Attività non trovata";
    if (lessonTraining) {
      title = lessonTraining.title;
    }

    return (
      <>
        <section className="my-4">
          <Container>
            <Title>{title}</Title>
            <ul>
              <li>data: {dateHelper.toITDate(lessonTraining?.date || '')}</li>
              <li>ora inizio: {lessonTraining?.hourStart || ''}</li>
              <li>docente: {lessonTraining?.teacher || ''}</li>
            </ul>
            <AdminLessonTrainingAnalyticsForm
              idLessonTrainingSchedule={idLessonTrainingSchedule}
              lessonTitle={title}
            />
          </Container>
        </section>
      </>
    );
  }
}

export default withRouter(LessonTrainingScheduleAnalytics);
